var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.$route.meta.isAuthPage)?_c('nav-bar'):_vm._e(),_c('v-main',[_c('layout'),_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }